(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3876],{

/***/ 68153:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/network/onboarding",
      function () {
        return __webpack_require__(15568);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Cookies; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50921);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);




function Cookies(props) {
    if (props.showPolicy) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            id: "cookies",
            className: "fixed w-full bottom-0 z-50 p-3 mb-0 bg-slate-400 flex justify-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    onClick: function() {
                        return props.setShowPolicy(false);
                    },
                    className: "mx-3 text-white hover:text-slate-300",
                    style: {
                        fontSize: 25
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "text-white text-center mb-0",
                    children: [
                        "By using this site, you agree to our",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                href: "/cookie-policy",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "text-white",
                                    children: " Cookie Policy "
                                })
                            })
                        }),
                        "and",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("u", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                href: "/privacy-policy",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "text-white",
                                    children: " Privacy Policy"
                                })
                            })
                        })
                    ]
                })
            ]
        }));
    }
    return null;
};


/***/ }),

/***/ 84114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js
var popover = __webpack_require__(86215);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 5 modules
var transition = __webpack_require__(33587);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/MenuIcon.js
var MenuIcon = __webpack_require__(69065);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/XIcon.js
var XIcon = __webpack_require__(5506);
// EXTERNAL MODULE: ./contexts/Auth.js
var Auth = __webpack_require__(92842);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next-intercom/dist/index.js
var dist = __webpack_require__(33854);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(52500);
// EXTERNAL MODULE: ./components/Cookies.js
var Cookies = __webpack_require__(36076);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
;// CONCATENATED MODULE: ./components/Layouts/Navbars/BizNav.js













var navigation = [];
function HomeNav() {
    var ref = (0,Auth/* useAuth */.a)(), user = ref.user, signOut = ref.signOut;
    var ref1 = (0,react.useState)(false), showPolicy = ref1[0], setShowPolicy = ref1[1];
    (0,react.useEffect)(function() {
        if (!config/* dev */.WI && user) {
            (0,dist.loadIntercom)({
                appId: 'zpntjk45',
                name: "",
                email: user ? user.email : "",
                ssr: false,
                initWindow: true,
                delay: 2000
            });
        } else if (!config/* dev */.WI) {
            (0,dist.loadIntercom)({
                appId: 'zpntjk45',
                ssr: false,
                initWindow: true,
                delay: 2000
            });
        }
        var cook = (0,lib.getCookie)("policy");
        if (!cook) {
            setShowPolicy(true);
            (0,lib.setCookie)("policy", "true");
        }
    }, [
        user
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J, {
        as: "header",
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cookies/* default */.Z, {
                showPolicy: showPolicy,
                setShowPolicy: setShowPolicy
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-slate-200/50 pt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                    className: "relative max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6",
                    "aria-label": "Global",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center flex-1 justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-between w-full md:w-auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: "/",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Plaza"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                        alt: "Plaza Logo",
                                                        src: "https://d28zq0um2frnpx.cloudfront.net/static/plaza-logto-tail.png",
                                                        width: 128,
                                                        height: 64,
                                                        objectFit: "contain"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "-mr-2 flex items-center md:hidden",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                                className: "bg-gray-900 rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-800 focus:outline-none focus:ring-2 focus-ring-inset focus:ring-white",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "Open main menu"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon/* default */.Z, {
                                                        className: "h-6 w-6",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden space-x-8 md:!flex md:ml-10 md:mr-10",
                                    children: navigation.map(function(item) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: item.href,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "text-base font-medium text-slate-500 hover:text-gray-800",
                                                children: item.name
                                            })
                                        }, item.name);
                                    })
                                })
                            ]
                        }),
                        user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden md:!flex md:items-center md:space-x-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center text-base font-medium text-gray-600",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return signOut();
                                        },
                                        className: "text-gray-900 hover:underline",
                                        children: "Logout"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/dashboard",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md hover:bg-fuchsia-800 text-white shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700",
                                        children: "Dashboard"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "hidden md:!flex md:items-center md:space-x-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/login",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "text-base font-medium text-slate-900 hover:text-gray-600",
                                        children: "Log in"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "#bookDemo",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md hover:bg-fuchsia-800 text-white shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700",
                                        children: "Book a Demo"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                as: react.Fragment,
                enter: "duration-150 ease-out",
                enterFrom: "opacity-0 scale-95",
                enterTo: "opacity-100 scale-100",
                leave: "duration-100 ease-in",
                leaveFrom: "opacity-100 scale-100",
                leaveTo: "opacity-0 scale-95",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                    focus: true,
                    className: "absolute z-10 top-0 inset-x-0 p-2 transition transform origin-top md:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "rounded-lg shadow-md bg-white ring-1 ring-black ring-opacity-5 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-5 pt-4 flex items-center justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                            alt: "Plaza",
                                            src: "https://d28zq0um2frnpx.cloudfront.net/static/plaza-logto-tail.png",
                                            width: 128,
                                            height: 64,
                                            objectFit: "contain"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "-mr-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                            className: "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-fuchsia-600",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Close menu"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XIcon/* default */.Z, {
                                                    className: "h-6 w-6",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pt-5 pb-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-2 space-y-1",
                                        children: navigation.map(function(item) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: item.href,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50",
                                                    children: item.name
                                                })
                                            }, item.name);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-6 px-5",
                                        children: user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                    href: "/dashboard",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "block text-center w-full py-3 px-4 rounded-md shadow shadow-fuchsia-500/50 bg-fuchsia-700 text-white font-medium hover:bg-fuchsia-900",
                                                        children: "Dashboard"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-center mt-4 text-base font-medium text-gray-600",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        onClick: function() {
                                                            return signOut();
                                                        },
                                                        className: "text-gray-900 hover:underline",
                                                        children: "Logout"
                                                    })
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "mt-6 px-5",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                        href: "#bookDemo",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "block text-center w-full py-3 px-4 rounded-md shadow shadow-fuchsia-500/50 bg-fuchsia-700 text-white font-medium hover:bg-fuchsia-900",
                                                            children: "Book a Demo"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-center text-base font-medium text-gray-600",
                                                    children: [
                                                        "Existing customer?",
                                                        ' ',
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                            href: "/login",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "text-gray-900 hover:underline",
                                                                children: "Login"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/Layouts/businessLayout.js



var Footer = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 3474).then(__webpack_require__.bind(__webpack_require__, 73193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73193)
            ];
        }
    }
});
function Layout(param) {
    var children = param.children;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeNav, {}),
            children
        ]
    }));
};


/***/ }),

/***/ 31331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wU": function() { return /* binding */ shallowEqual; },
/* harmony export */   "_i": function() { return /* binding */ fetcher; },
/* harmony export */   "mJ": function() { return /* binding */ uploadPhoto; }
/* harmony export */ });
/* unused harmony exports default, truncateString, toggleLikes, handleDateFilter */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6644);


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function changeDateFormat(published) {
    //yyyy-mm-ddT00:00:00+00:00 --> M dd, yyyy, h:mm A
    var date = new Date(published);
    date = date.toString().split(/\s(.+)/)[1];
    var dates = date.split(" ");
    date = dates[0] + " " + dates[1] + ", " + dates[2];
    return date;
};
function truncateString(str, length) {
    return str.length > length ? str.substring(0, length - 3) + '...' : str;
}
function toggleLikes(e, bool, projectId, profileId) {
    return _toggleLikes.apply(this, arguments);
}
function _toggleLikes() {
    _toggleLikes = _asyncToGenerator(regeneratorRuntime.mark(function _callee(e, bool, projectId, profileId) {
        var row_id, ref, like, error2, ref1, data, error, ref2, like1, error1, ref3, data1, error21;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    row_id = projectId;
                    if (!bool) {
                        _ctx.next = 15;
                        break;
                    }
                    _ctx.next = 4;
                    return supabase.from('main_like').insert({
                        profile: profileId,
                        project: projectId
                    });
                case 4:
                    ref = _ctx.sent;
                    like = ref.data;
                    error2 = ref.error2;
                    _ctx.next = 9;
                    return supabase.rpc('increment_project_likes', {
                        row_id: row_id
                    }, {
                        count: 'exact'
                    });
                case 9:
                    ref1 = _ctx.sent;
                    data = ref1.data;
                    error = ref1.error;
                    if (error) console.error(error);
                    _ctx.next = 28;
                    break;
                case 15:
                    console.log(false);
                    _ctx.next = 18;
                    return supabase.from('main_like').delete().match({
                        profile: profileId,
                        project: projectId
                    });
                case 18:
                    ref2 = _ctx.sent;
                    like1 = ref2.data;
                    error1 = ref2.error;
                    console.log(error1);
                    _ctx.next = 24;
                    return supabase.rpc('reduce_project_likes', {
                        row_id: row_id
                    }, {
                        count: 'exact'
                    });
                case 24:
                    ref3 = _ctx.sent;
                    data1 = ref3.data;
                    error21 = ref3.error2;
                    if (error1) console.error(error1);
                case 28:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _toggleLikes.apply(this, arguments);
}
function shallowEqual(object1, object2) {
    var keys1 = Object.keys(object1);
    var keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (object1[key] !== object2[key]) {
                return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function fetcher(table, query, param, id, index1, custom, date_range) {
    return _fetcher.apply(this, arguments);
}
function _fetcher() {
    _fetcher = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(table, query, param, id, index1, custom, date_range) {
        var ref, data, error, ref4, data2, error2, ref5, data3, error3, ref6, data4, error4, ref7, data5, error5, ref8, data6, error6, obj, ref9, data7, error7, ref10, data8, error8;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(!param && !id)) {
                        _ctx.next = 10;
                        break;
                    }
                    _ctx.next = 3;
                    return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_1__/* .supabase.from */ .O.from(table).select(query);
                case 3:
                    ref = _ctx.sent;
                    data = ref.data;
                    error = ref.error;
                    error && console.log(error);
                    return _ctx.abrupt("return", data);
                case 10:
                    if (!date_range) {
                        _ctx.next = 20;
                        break;
                    }
                    if (!(table === "main_meeting" && custom === "payments")) {
                        _ctx.next = 20;
                        break;
                    }
                    _ctx.next = 14;
                    return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_1__/* .supabase.from */ .O.from(table).select(query).eq(param, id).lt('created_at', date_range[0]).gt('created_at', date_range[1]).gt('cost', 0).order(custom === "payments" ? 'created_at' : 'appointment_datetime', {
                        ascending: false
                    });
                case 14:
                    ref4 = _ctx.sent;
                    data2 = ref4.data;
                    error2 = ref4.error;
                    data2 = data2.filter(function(value, index, self) {
                        return index === self.findIndex(function(t) {
                            return t.subtype === value.subtype;
                        });
                    });
                    error2 && console.log(error2);
                    return _ctx.abrupt("return", data2);
                case 20:
                    if (!(table === "main_meeting")) {
                        _ctx.next = 30;
                        break;
                    }
                    _ctx.next = 23;
                    return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_1__/* .supabase.from */ .O.from(table).select(query).eq(param, id).order('appointment_datetime', {
                        ascending: true
                    });
                case 23:
                    ref5 = _ctx.sent;
                    data3 = ref5.data;
                    error3 = ref5.error;
                    error3 && console.log(error3);
                    return _ctx.abrupt("return", data3);
                case 30:
                    if (!(table === "main_activity" && custom === "services")) {
                        _ctx.next = 40;
                        break;
                    }
                    _ctx.next = 33;
                    return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_1__/* .supabase.from */ .O.from(table).select(query).eq(param, id).order('created_at', {
                        ascending: false
                    });
                case 33:
                    ref6 = _ctx.sent;
                    data4 = ref6.data;
                    error4 = ref6.error;
                    error4 && console.log(error4);
                    return _ctx.abrupt("return", data4);
                case 40:
                    if (!(table === "main_conversation_profile_unread")) {
                        _ctx.next = 62;
                        break;
                    }
                    if (id) {
                        _ctx.next = 43;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 43:
                    if (!(id.account_type === "client")) {
                        _ctx.next = 53;
                        break;
                    }
                    _ctx.next = 46;
                    return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_1__/* .supabase.from */ .O.from("main_conversation").select("client_unread, client_profile_id(user_id)").eq("client_profile_id", id.id).eq("client_unread", true);
                case 46:
                    ref7 = _ctx.sent;
                    data5 = ref7.data;
                    error5 = ref7.error;
                    error5 && console.log(error5);
                    return _ctx.abrupt("return", data5);
                case 53:
                    _ctx.next = 55;
                    return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_1__/* .supabase.from */ .O.from("main_conversation").select("profile_unread, profile_id(user_id)").eq("profile_id", id.id).eq("profile_unread", true);
                case 55:
                    ref8 = _ctx.sent;
                    data6 = ref8.data;
                    error6 = ref8.error;
                    error6 && console.log(error6);
                    return _ctx.abrupt("return", data6);
                case 60:
                    _ctx.next = 82;
                    break;
                case 62:
                    if (!(table === "main_conversation")) {
                        _ctx.next = 74;
                        break;
                    }
                    obj = custom === "business" ? {
                        "profile_id": id
                    } : {
                        "client_profile_id": id
                    };
                    console.log("query Obj");
                    _ctx.next = 67;
                    return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_1__/* .supabase.from */ .O.from("main_conversation").select(query).match(obj).order("last_message_date", {
                        ascending: false
                    });
                case 67:
                    ref9 = _ctx.sent;
                    data7 = ref9.data;
                    error7 = ref9.error;
                    // .range(start, end)
                    error7 && console.log(error7);
                    return _ctx.abrupt("return", data7);
                case 74:
                    _ctx.next = 76;
                    return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_1__/* .supabase.from */ .O.from(table).select(query).eq(param, id).order("created_at", {
                        ascending: false
                    });
                case 76:
                    ref10 = _ctx.sent;
                    data8 = ref10.data;
                    error8 = ref10.error;
                    console.log("details");
                    error8 && console.log(error8);
                    return _ctx.abrupt("return", data8);
                case 82:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetcher.apply(this, arguments);
}
;
//direcotry should be user_images or article_images
function uploadPhoto(e, username) {
    return _uploadPhoto.apply(this, arguments);
}
function _uploadPhoto() {
    _uploadPhoto = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e, username) {
        var file, filename, filepath, res, ref, url, fields, formData, upload;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    console.log("uplaoding photo");
                    file = e.target.files[0];
                    filename = encodeURIComponent(file.name);
                    filepath = "media/images/" + username + "/" + filename;
                    _ctx.next = 6;
                    return fetch("/api/upload/upload-url?file=".concat(filepath));
                case 6:
                    res = _ctx.sent;
                    _ctx.next = 9;
                    return res.json();
                case 9:
                    ref = _ctx.sent;
                    url = ref.url;
                    fields = ref.fields;
                    formData = new FormData();
                    Object.entries(_objectSpread({}, fields, {
                        file: file
                    })).forEach(function(param) {
                        var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                        formData.append(key, value);
                    });
                    console.log("url", url);
                    _ctx.next = 17;
                    return fetch(url, {
                        method: 'POST',
                        body: formData
                    });
                case 17:
                    upload = _ctx.sent;
                    if (!upload.ok) {
                        _ctx.next = 23;
                        break;
                    }
                    console.log('Uploaded successfully!');
                    return _ctx.abrupt("return", filepath);
                case 23:
                    console.error('Upload failed.');
                    return _ctx.abrupt("return", null);
                case 25:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _uploadPhoto.apply(this, arguments);
}
;
function handleDateFilter(e) {
    return _handleDateFilter.apply(this, arguments);
}
function _handleDateFilter() {
    _handleDateFilter = _asyncToGenerator(regeneratorRuntime.mark(function _callee(e) {
        var _target, name, value, thrityDaysAgo, yesterdayStart, yesterdayEnd, todayStart, todayEnd;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _target = e.target, name = _target.name, value = _target.value;
                    setDateFilter(value);
                    if (value === "7") {
                        setDateRange([
                            today,
                            sevenDaysAgo
                        ]);
                    } else if (value === "30") {
                        thrityDaysAgo = DateTime.now().plus({
                            days: -29
                        }).toISO();
                        setDateRange([
                            today,
                            thrityDaysAgo
                        ]);
                    } else if (value === "yesterday") {
                        yesterdayStart = DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).plus({
                            days: -1
                        }).startOf('day').toISO();
                        yesterdayEnd = DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).plus({
                            days: -1
                        }).endOf('day').toISO();
                        setDateRange([
                            yesterdayStart,
                            yesterdayEnd
                        ]);
                    } else if (value === "today") {
                        todayStart = DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).startOf('day').toISO();
                        todayEnd = DateTime.now().setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).endOf('day').toISO();
                        setDateRange([
                            todayStart,
                            todayEnd
                        ]);
                    } else {
                        //custom
                        setCustomDate({
                            start: null,
                            end: null
                        });
                    }
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _handleDateFilter.apply(this, arguments);
}


/***/ }),

/***/ 15568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Onboarding; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6644);
/* harmony import */ var _components_Layouts_businessLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84114);
/* harmony import */ var _components_Notification__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96691);
/* harmony import */ var react_alert__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19412);
/* harmony import */ var _contexts_Auth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92842);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52500);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25675);
/* harmony import */ var _components_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31331);












function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Onboarding() {
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), subPage = ref8[0], setSubPage = ref8[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), profile = ref1[0], setProfile = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), error1 = ref2[0], setError = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), picLoading = ref4[0], setPicLoading = ref4[1];
    var alert = (0,react_alert__WEBPACK_IMPORTED_MODULE_7__/* .useAlert */ .VY)();
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), selected = ref5[0], setSelected = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        education: "",
        pitch: "",
        niche: "",
        info: ""
    }), listing = ref6[0], setListing = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        monthly_lead_limit: 0,
        credit_card: ""
    }), billing = ref7[0], setBilling = ref7[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var user = (0,_contexts_Auth__WEBPACK_IMPORTED_MODULE_8__/* .useAuth */ .a)().user;
    var handleChange = function(e) {
        var newlisting = _objectSpread({}, listing);
        newlisting[e.target.name] = e.target.value;
        setListing(newlisting);
    };
    var handleBillingChange = function(e) {
        var newBilling = _objectSpread({}, billing);
        newBilling[e.target.name] = e.target.value;
        setBilling(newBilling);
    };
    var next = function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(subPage === 0)) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 3;
                        return submitListing();
                    case 3:
                        _ctx.next = 14;
                        break;
                    case 5:
                        if (!(subPage === 1)) {
                            _ctx.next = 14;
                            break;
                        }
                        if (selected) {
                            _ctx.next = 9;
                            break;
                        }
                        alert.error("No pricing model selected");
                        return _ctx.abrupt("return");
                    case 9:
                        _ctx.next = 11;
                        return submitPricing();
                    case 11:
                        if (!(selected === "percentage")) {
                            _ctx.next = 14;
                            break;
                        }
                        router.push("/dashboard");
                        return _ctx.abrupt("return");
                    case 14:
                        if (!(subPage === 2)) {
                            _ctx.next = 19;
                            break;
                        }
                        _ctx.next = 17;
                        return submitLeadLimit();
                    case 17:
                        router.push("/dashboard");
                        return _ctx.abrupt("return");
                    case 19:
                        setSubPage(subPage + 1);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function next() {
            return _ref.apply(this, arguments);
        };
    }();
    var uploadImage = function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e, type) {
            var obj, filePath, ref, data, error, newProf;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        filePath = "";
                        setPicLoading(true);
                        _ctx.next = 5;
                        return (0,_components_utils__WEBPACK_IMPORTED_MODULE_11__/* .uploadPhoto */ .mJ)(e, profile.name);
                    case 5:
                        filePath = _ctx.sent;
                        _ctx.next = 8;
                        return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_4__/* .supabase.from */ .O.from("main_profile").update({
                            user_image: filePath
                        }).match({
                            user_id: user.id
                        });
                    case 8:
                        ref = _ctx.sent;
                        data = ref.data;
                        error = ref.error;
                        newProf = _objectSpread({}, profile);
                        newProf.user_image = filePath;
                        setProfile(newProf);
                        setPicLoading(false);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function uploadImage(e, type) {
            return _ref.apply(this, arguments);
        };
    }();
    var submitLeadLimit = function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, data, error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.next = 3;
                        return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_4__/* .supabase.from */ .O.from("main_listing").update({
                            monthly_lead_limit: billing.monthly_lead_limit
                        }).match({
                            id: listing.id
                        });
                    case 3:
                        ref = _ctx.sent;
                        data = ref.data;
                        error = ref.error;
                        error && console.log(error);
                        // const {data, error} = await supabase
                        // .from("main_listing")
                        // .update({
                        // })
                        // .match({ })
                        setLoading(false);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitLeadLimit() {
            return _ref.apply(this, arguments);
        };
    }();
    var submitPricing = function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, data, error;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.next = 3;
                        return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_4__/* .supabase.from */ .O.from("main_listing").update({
                            type: selected
                        }).match({
                            id: listing.id
                        });
                    case 3:
                        ref = _ctx.sent;
                        data = ref.data;
                        error = ref.error;
                        error && console.log(error);
                        // const {data, error} = await supabase
                        // .from("main_listing")
                        // .update({
                        // })
                        // .match({ })
                        setLoading(false);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitPricing() {
            return _ref.apply(this, arguments);
        };
    }();
    var submitListing = function() {
        var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, data, error, prof;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.next = 3;
                        return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_4__/* .supabase.from */ .O.from("main_listing").insert(listing);
                    case 3:
                        ref = _ctx.sent;
                        data = ref.data;
                        error = ref.error;
                        error && console.log(error);
                        //get id and add to profile
                        console.log(data[0]);
                        setListing(data[0]);
                        _ctx.next = 11;
                        return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_4__/* .supabase.from */ .O.from("main_profile").update({
                            listing_id: data[0].id
                        }).match({
                            user_id: user.id
                        });
                    case 11:
                        prof = _ctx.sent;
                        prof.error && console.log(prof.error);
                        setLoading(false);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitListing() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var getProfile = function() {
            var _ref = _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, data, error;
                return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return _utils_supabaseClient__WEBPACK_IMPORTED_MODULE_4__/* .supabase.from */ .O.from("main_profile").select("id, name, user_id, user_image, listing_id(id,type)").match({
                                user_id: user.id
                            });
                        case 2:
                            ref = _ctx.sent;
                            data = ref.data;
                            error = ref.error;
                            error && console.log(error);
                            setProfile(data[0]);
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getProfile() {
                return _ref.apply(this, arguments);
            };
        }();
        if (user) {
            getProfile();
        }
    }, [
        user
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "bg-slate-200/50 ".concat(subPage === 2 ? "h-screen" : "h-full", " pb-48 overflow-hidden"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "blur-3xl ml-10 absolute h-32 w-32 -z-10 bg-fuchsia-400"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "relative ",
                id: "bookDemo",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                        className: "text-center text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl",
                        children: "Onboarding"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "w-full lg:w-1/2 mx-auto px-20 lg:px-0 mt-10 sm:mt-12",
                        id: "waitlist",
                        children: [
                            subPage === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "sm:flex",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "min-w-0 flex-1 space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                    className: "text-slate-600 mb-2",
                                                    children: "Profile Pic "
                                                }),
                                                picLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    className: "flex justify-center",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                                        className: "animate-spin h-10 w-10 my- text-zinc-900 ",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        fill: "none",
                                                        viewBox: "0 0 24 24",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
                                                                className: "opacity-25",
                                                                cx: "12",
                                                                cy: "12",
                                                                r: "10",
                                                                stroke: "currentColor",
                                                                strokeWidth: "4"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                                className: "opacity-75",
                                                                fill: "currentColor",
                                                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                            })
                                                        ]
                                                    })
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    children: (profile === null || profile === void 0 ? void 0 : profile.user_image) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: "flex mb-4 justify-between items-center w-full",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_10__["default"], {
                                                                className: "rounded-full",
                                                                src: "".concat(_config__WEBPACK_IMPORTED_MODULE_9__/* .cloudfront */ .bG, "/").concat(profile.user_image),
                                                                width: 80,
                                                                height: 80,
                                                                alt: profile.name,
                                                                objectFit: "cover"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                                className: "",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                                                        htmlFor: "uploadProfile",
                                                                        className: " py-2 px-4 mb-5 w-56 text-xs rounded-md bg-slate-100 hover:bg-slate-200 font-medium ",
                                                                        children: "Change Image"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                                        onChange: function(e) {
                                                                            return uploadImage(e, "user_image");
                                                                        },
                                                                        type: "file",
                                                                        id: "uploadProfile",
                                                                        className: "hidden py-2 px-4 mb-5 text-xs rounded-md border-2 bg-white border-fuchsia-700 shadow-lg font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 focus:ring-offset-gray-900"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "flex justify-between items-center w-full",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                            className: " group",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                                onChange: function(e) {
                                                                    return uploadImage(e, "user_image");
                                                                },
                                                                type: "file",
                                                                placeholder: "Upload Image",
                                                                className: " py-2 px-4 mb-5 w-56 text-xs rounded-md bg-slate-200 font-medium "
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                    className: "text-slate-600 mb-2",
                                                    children: "Enter Education "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                    name: "education",
                                                    defaultValue: listing.name,
                                                    onChange: handleChange,
                                                    className: "block w-full px-4 py-3 rounded-md border-0 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-700"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                    className: "text-slate-600 mb-2",
                                                    children: "Pitch your coaching to potential clients. (2 - 5 sentences) "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("textarea", {
                                                    name: "pitch",
                                                    defaultValue: listing.email,
                                                    onChange: handleChange,
                                                    className: "block text-sm w-full px-4 py-3 rounded-md border-0 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-700"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                    className: "text-slate-600 mb-2",
                                                    children: "What is your coaching niche? (Helping physicians with burnout, How to market your own physician practice) "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("textarea", {
                                                    name: "niche",
                                                    defaultValue: listing.type,
                                                    onChange: handleChange,
                                                    className: "block w-full px-4 py-3 rounded-md border-0 text-sm text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-700"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                    className: "text-slate-600 mb-2",
                                                    children: "Additional background information to improve profile "
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("textarea", {
                                                    name: "info",
                                                    defaultValue: listing.notes,
                                                    onChange: handleChange,
                                                    className: "block w-full px-4 py-3 rounded-md border-0 text-sm text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-700"
                                                })
                                            ]
                                        }),
                                        error1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: "text-red-600",
                                            children: error1
                                        })
                                    ]
                                })
                            }),
                            subPage === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                                        className: "text-slate-800 font-semibold",
                                        children: "Pricing Model"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                        className: "mb-4",
                                        children: "How would you like to offer your services on the marketplace?"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "space-y-3",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                                                onClick: function() {
                                                    return setSelected("per-lead");
                                                },
                                                className: "".concat(selected === "per-lead" && "border-fuchsia-500 border-2", " text-left rounded-lg hover:bg-slate-100 bg-white p-5 text-slate-700"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "Per Lead Pricing"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "$30*"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                className: "font-bold ",
                                                                children: "How it Works:"
                                                            }),
                                                            " Potential clients can send you a message to inquire about your services. You are charged if you would like to respond to an inquiry.  Spam messages are not counted as a billable event."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                                                onClick: function() {
                                                    return setSelected("per-discovery-call");
                                                },
                                                className: "".concat(selected === "per-discovery-call" && "border-fuchsia-500 border-2", " text-left rounded-lg hover:bg-slate-100 bg-white p-5 text-slate-700"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "Per Discovery Call Pricing"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "$50*"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                className: "font-bold ",
                                                                children: "How it Works:"
                                                            }),
                                                            " Host only your discovery call on Plaza's video platform.  You are only charged if a potential client shows up and joins your video call."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                                                onClick: function() {
                                                    return setSelected("percentage");
                                                },
                                                className: "".concat(selected === "percentage" && "border-fuchsia-500 border-2", " text-left  rounded-lg hover:bg-slate-100 bg-white p-5 text-slate-700"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "Percentage of Coaching Package"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                        children: "10%"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                className: "font-bold ",
                                                                children: "How it Works:"
                                                            }),
                                                            " Host your entire coaching package on Plaza's all-in-one coaching platform where the only charge is a percentage of your coaching package. With this option, you only pay a fee if a client signs up for your services"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                className: "text-slate-700",
                                                children: "*starting prices for new coaches"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            subPage === 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "space-y-6",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                className: "text-slate-600 mb-2",
                                                children: "Estimated Monthly Cost: "
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                className: "text-slate-800 text-xl font-bold",
                                                children: [
                                                    "$ ",
                                                    billing.monthly_lead_limit * (selected === "per-lead" ? 30 : 50)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                className: "text-slate-600 mb-2",
                                                children: [
                                                    "*Note: Before being charged, we'll check-in with you to make sure you are satisfied with the quality of your ",
                                                    selected === "per-lead" ? "leads" : "discovery calls"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                className: "text-slate-600 mb-2",
                                                children: [
                                                    "Monthly ",
                                                    selected === "per-lead" ? "Lead" : "Discovery Call",
                                                    " Limit "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                name: "monthly_lead_limit",
                                                defaultValue: billing.monthly_lead_limit,
                                                onChange: handleBillingChange,
                                                type: "number",
                                                className: "block w-full px-4 py-3 rounded-md border-0 text-base text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-fuchsia-700 "
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "mt-6",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                    onClick: next,
                                    className: "block w-full py-3 px-4 rounded-md hover:text-gray-900 shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700 text-white font-medium hover:bg-fuchsia-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 focus:ring-offset-gray-900",
                                    children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "flex justify-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                            className: "animate-spin h-5 w-5 my-auto text-zinc-100 ",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            fill: "none",
                                            viewBox: "0 0 24 24",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("circle", {
                                                    className: "opacity-25",
                                                    cx: "12",
                                                    cy: "12",
                                                    r: "10",
                                                    stroke: "currentColor",
                                                    strokeWidth: "4"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                                                    className: "opacity-75",
                                                    fill: "currentColor",
                                                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                })
                                            ]
                                        })
                                    }) : "Next"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var alertOptions = {
    // you can also just use 'bottom right'
    position: react_alert__WEBPACK_IMPORTED_MODULE_7__/* .positions.BOTTOM_RIGHT */ .m7.BOTTOM_RIGHT,
    timeout: 3000,
    offset: '10px',
    containerStyle: {
        'zIndex': '9999'
    },
    // you can also just use 'fade'
    transition: react_alert__WEBPACK_IMPORTED_MODULE_7__/* .transitions.FADE */ .pB.FADE
};
Onboarding.getLayout = function getLayout(page) {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_alert__WEBPACK_IMPORTED_MODULE_7__/* .Provider */ .zt, _objectSpread({
        template: _components_Notification__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z
    }, alertOptions, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_contexts_Auth__WEBPACK_IMPORTED_MODULE_8__/* .AuthProvider */ .H, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Layouts_businessLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: page
            })
        })
    })));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,3640,3616,7612,9774,2888,179], function() { return __webpack_exec__(68153); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);